const OVERRIDES = {
  sr: "sr-Latn-RS",
  en: "en-GB",
};

export const resolveLocale = (lang) => {
  const l = (lang || "").toLowerCase();
  const locale = OVERRIDES[l] || l || "en";

  const supported = Intl.DateTimeFormat.supportedLocalesOf([locale]).length > 0;

  return supported ? locale : "en-GB";
};

export const getMonthNames = (locale) => {
  const fmt = new Intl.DateTimeFormat(locale, { month: "long" });
  return Array.from({ length: 12 }, (_, i) => fmt.format(new Date(2020, i, 1)));
};

export const getWeekdayShort = (locale, date) =>
  new Intl.DateTimeFormat(locale, { weekday: "short" }).format(date);
